import Card from "antd/es/card/Card";
import InsurancePlans from "entities/InsurancePlans";
import { isEmpty } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAdd, MdOutlineUploadFile } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Header from "shared/components/Header";
import Search from "shared/components/Input";
import { useMutation } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import RisksDrawer from "./RisksDrawer";
import View from "./View";
import YamlImportDrawer from "./YamlImportDrawer";

const List = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.INSURANCE_PLAN);
  const LIST = t("LIST", { returnObjects: true });
  const [pagination, setPagination] = useState({});
  const [openCreateDrawer, setOpenCreateDrawer] = useState(false);
  const [openYamlImport, setOpenYamlImport] = useState(false);
  const [search, setSearch] = useState("");
  const filter = {
    ...INITIAL_VALUES,
    like: isEmpty(search)
      ? undefined
      : {
          OR: [
            { name: `%${search}%` },
            { description: `%${search}%` },
            { alias: `%${search}%` },
            { identifier: `%${search}%` },
          ],
        },
  };
  const navigate = useNavigate();

  const [duplicateInsurancePlan] = useMutation(
    graphql.mutations.DUPLICATE_INSURANCE_PLAN,
    {
      refetchQueries: [
        {
          query: graphql.queries.INSURANCE_PLANS,
          awaitRefetchQueries: true,
          variables: {
            ...filter,
          },
        },
      ],
      onCompleted: ({ duplicateInsurancePlan }) => {
        navigate(
          `${SCREENS.PRIVATE.ADMIN.INSURANCE_PLANS.DETAIL.path}/${duplicateInsurancePlan.id}`,
        );
      },
    },
  );

  const buttons = [
    {
      icon: <MdOutlineUploadFile size={24} />,
      text: LIST.HEADER.IMPORT_DOCS,
      type: "primary--outlined",
      onClick: () =>
        navigate(SCREENS.PRIVATE.ADMIN.INSURANCE_PLANS.IMPORT_DOCS.path),
    },
    {
      icon: <MdOutlineUploadFile size={24} />,
      text: LIST.HEADER.IMPORT_PARAMS,
      type: "primary--outlined",
      onClick: () =>
        navigate(SCREENS.PRIVATE.ADMIN.INSURANCE_PLANS.IMPORT_PARAMS.path),
    },
    {
      icon: <MdOutlineUploadFile size={24} />,
      text: LIST.HEADER.IMPORT_YAML,
      type: "primary--outlined",
      onClick: () => setOpenYamlImport(true),
    },
    {
      icon: <MdAdd size={24} />,
      text: LIST.HEADER.SAVE,
      onClick: () => setOpenCreateDrawer(true),
    },
  ];

  return (
    <>
      <Header title={LIST.HEADER.TITLE} actions={buttons} />
      <Card type="simple">
        <div className="m-bottom-20 grid--4">
          <Search
            placeholder={LIST.FILTERS.SEARCH}
            type="search"
            onChange={({ target: { value } }) => {
              setPagination((prev) => ({ ...prev, skip: 0 }));
              setSearch(value);
            }}
          />
        </div>
        <InsurancePlans
          View={View}
          duplicate={duplicateInsurancePlan}
          filter={{ ...filter, ...pagination }}
          setValues={setPagination}
          skip={pagination.skip || 0}
          NoData={View}
        />
        <RisksDrawer
          open={openCreateDrawer}
          onClose={() => setOpenCreateDrawer(false)}
        />
        <YamlImportDrawer
          open={openYamlImport}
          onClose={() => setOpenYamlImport(false)}
        />
      </Card>
    </>
  );
};

export default List;
